export const DEFAULT_API_RECORDS_LIMIT = 50;
export const COMMUNITY_AVATAR_BASE_URL = `https://ui-avatars.com/api/?name={{NAME}}&size=256&background=C4C4C4&color=FFFFFF&bold=true&format=png`;

export const PAGE_VIEWS = {
  SUPPLIER_MANAGEMENT_VIEW: "SUPPLIER_MANAGEMENT_VIEW",
  COMMUNITY_MANAGEMENT_VIEW: "COMMUNITY_MANAGEMENT_VIEW",
};
